<template>
  <div class="page">
    <Header
        :title=itemTitle
    />
    <div class="container dashboard card">
      <div class="item-body">
        {{ content }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Header from './Header.vue';
import {TokenMixin} from '@/assets/js/mixins/token-mixin';
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: 'ItemLog',
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  components: {
    Header,
  },
  data() {
    return {
      error: '',
      content: '...',
      itemTitle: '...',
      action: 'add',
      apiUrl: '',
      redirectToUrl: '',
      apiItem: '/api/log/',
      login: '/login',
      loading: 'loaded',
      showLoader: true,
    }
  },
  methods: {
    moveUp() {
      window.scrollTo(0, 0);
    },
    loadData() {
      let currentQuery = this.$route.query.id ? this.$route.query.id : '';
      if (currentQuery === '') {
        return;
      }
      let loader
      if (this.showLoader) {
        loader = this.$loading.show();
      }
      this.error = '';
      axios.get(this.apiItem + currentQuery,
          this.authRespConf())
          .catch((err) => {
            if (this.showLoader) {
              loader.hide();
            }
            this.errorHandle(err, true, true);
          })
          .then(res => {
            if (this.showLoader) {
              loader.hide();
            }
            console.log('loaded data', res);
            this.content = res.data.data.Data;
          });
    },
  },
  watch: {
    '$route': 'loadData'
  },
  created: function () {
    this.loadData();
  }
}
</script>
